import * as environment from '../../../config/environment';

import { BaseAPI } from "../../BaseAPI";

class NobetciEczaneAPI extends BaseAPI {
    constructor() {
        const baseUrl = environment.API_URL + "NobetciEczaneListe";
        super(baseUrl);
    }
    getNobetciEczaneListe(tarih: Date) {
        return this.get("", { params: { tarih: tarih } })


    }
}
export default new NobetciEczaneAPI();
class NobetciEczaneRequest {
    public tarih: Date;

    constructor(tarih: Date) {
        this.tarih = tarih;
    }
}
export { NobetciEczaneRequest };